import React from "react";

const HeaderSocials = () => {
  return (
    <div className="home__socials">
      {/* <a
        href="https://instagram.com/_ahmedelrefa3y"
        className="home__social-link"
        target="_blank"
      >
        <i className="fa-brands fa-instagram"></i>
      </a> */}

      {/* <a
        href="https://twitter.com/ahmedza76141863"
        className=" home__social-link"
        target="_blank"
      >
        <i className="fa-brands fa-x-twitter"></i>
      </a> */}

      <a
        href="https://github.com/AhmedEl-Refa3y"
        className="home__social-link"
        target="_blank"
      >
        <i className="fa-brands fa-github"></i>
      </a>

      <a
        href="https://www.linkedin.com/in/ahmedelrefay/"
        className="home__social-link"
        target="_blank"
      >
        <i className="fa-brands fa-linkedin"></i>
      </a>

      <a
        href="mailto:eng.ahmed.elrefa3y@gmail.com"
        className="home__social-link"
        target="_blank"
      >
        <i className="fa-solid fa-envelope"></i>
      </a>

      {/* <a
        href="https://facebook.com/احمد الرفاعي"
        className="home__social-link"
        target="_blank"
      >
        <i className="fa-brands fa-facebook"></i>
      </a> */}

      <a
        href="https://wa.me/01122072799"
        className="home__social-link"
        target="_blank"
      >
        <i className="fa-brands fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default HeaderSocials;
